define("auth/routes/application", ["exports", "@ember/routing/route"], function (_exports, _route) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class UserRoute extends _route.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "queryParams", {
        gspk: {},
        // Partnerstack Partner Key
        gsxid: {},
        // Partnerstack ID
        isSsoLogin: {},
        ssoAppName: {}
      });

      _defineProperty(this, "isSsoLogin", void 0);
    }

    model(_ref) {
      let {
        isSsoLogin
      } = _ref;
      this.isSsoLogin = isSsoLogin;
    }

  }

  _exports.default = UserRoute;
});